import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import TableContainer from "../../../components/layout/table-container/table-container";
import { manufacturerPremiumVersionList } from "../../../redux/actions/manufacturerActions";
import UpArrow from "../../../assets/icons/filterArrowUp.svg";
import DownArrow from "../../../assets/icons/filterArrowDown.svg";
import searcher from "../../../assets/icons/searchInput.svg";
import back from "../../../assets/icons/back.svg";
import LoadingSpinnerTable from "../../../components/utilites/loaderSpinningContainer";
import { useLocation, useNavigate } from "react-router-dom";
import MainLayout from "../../../components/layout/mainLayout/mainLayout";
import NumberPagination from "../../../components/Pagination/number-pagination";

const ManufacturerPremiumVersionTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const status = queryParamsData.get("status") ?? "";
  const search = queryParamsData.get("search") ?? "";
  const componentRef = useRef();
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [openStatus, setOpenStatus] = useState(false);
  const [manufacturerVersionListData, setManufacturerVersionListData] =
    useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(
      manufacturerPremiumVersionList(
        { page, search, status },
        onSuccess,
        onError
      )
    );
  }, [page, status, search, dispatch]);

  const onSuccess = (data) => {
    console.log(data.data.data);
    setManufacturerVersionListData(data.data.data);
    setLoading(false);
  };

  const onError = (err) => {
    console.log(err);
    setLoading(false);
  };

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenStatus(false);
    }
  };

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <MainLayout breadCrumb="ADMIN  /  Manufacturer  / Version History">
      <div>
        <div className="search-container d-flex justify-content-between ">
          <div className="d-flex w-100">
            <div
              className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
              onClick={() => navigate("/manufacturer/premium-list")}
            >
              <img src={back} alt="back_btn" />
              <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                BACK
              </span>
            </div>
            <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
              <img className="styled-SVG" src={searcher} color={""} alt="o" />
              <input
                value={search}
                className="search-input fs_14 fw_400 px-2 text-dark"
                type="text"
                placeholder="Search manufacturers here by manufacturer ID, manufacturer name..."
                onChange={(e) =>
                  navigate(
                    `/manufacturer/premium-list/version-list?page=1${
                      e.target.value ? `&search=${e.target.value}` : ""
                    }${status ? `&status=${status}` : ""}`
                  )
                }
              />
            </div>
          </div>
        </div>
        <>
          <TableContainer>
            <thead>
              <tr className="table-rows color_747f9e">
                <th className="table-heads " width={"4%"}>
                  #
                </th>
                <th className="table-heads " width={"10%"}>
                  Manufacturer ID
                </th>
                <th className="table-heads " width={"12%"}>
                  Manufacturer Name
                </th>
                <th className="table-heads " width={"6%"}>
                  No. of Orders
                </th>
                <th className="table-heads " width={"6%"}>
                  No. of Distributors
                </th>
                <th ref={componentRef} className="table-heads " width={"8%"}>
                  <span
                    className={
                      openStatus
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                    onClick={() => setOpenStatus(!openStatus)}
                  >
                    <span className={status ? "Medium_Purple fw_700" : ""}>
                      Status
                    </span>
                    {openStatus ? (
                      <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                    ) : (
                      <img src={DownArrow} className="mx-1" alt="v" />
                    )}
                  </span>
                  {openStatus && (
                    <div className=" position-relative">
                      <div className="position-absolute status-container d-flex gap-3 px-3">
                        <div className="d-flex align-items-center cursor_pointer">
                          <input
                            className="radio me-2  cursor_pointer"
                            type="radio"
                            id="Active"
                            name="status"
                            value={"active"}
                            checked={status === "active"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/manufacturer/premium-list/version-list?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=active`
                              );
                            }}
                          />
                          <label
                            htmlFor="Active"
                            className={
                              status === "active"
                                ? "color_262c3d  cursor_pointer"
                                : "color_747f9e  cursor_pointer"
                            }
                          >
                            Active
                          </label>
                        </div>
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2 cursor_pointer"
                            type="radio"
                            id="Inactive"
                            name="status"
                            value={"inactive"}
                            checked={status === "inactive"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/manufacturer/premium-list/version-list?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=inactive`
                              );
                            }}
                          />
                          <label
                            htmlFor="Inactive"
                            className={
                              status === "inactive"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Inactive
                          </label>
                        </div>
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2 cursor_pointer"
                            type="radio"
                            id="Draft"
                            name="status"
                            value={"draft"}
                            checked={status === "draft"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/manufacturer/premium-list/version-list?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=draft`
                              );
                            }}
                          />
                          <label
                            htmlFor="Draft"
                            className={
                              status === "draft"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Draft
                          </label>
                        </div>

                        <button
                          className="filter-btn px-2 py-0 my-2 fs_12"
                          style={{ height: "28px" }}
                          onClick={() => {
                            setOpenStatus(!openStatus);
                            navigate(
                              `/manufacturer/premium-list/version-list?page=1${
                                search ? `&search=${search}` : ""
                              }`
                            );
                          }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  )}
                </th>
                <th className="table-heads " width={"18%"}>
                  Actions
                </th>
              </tr>
            </thead>
            {loading === true ? (
              <div className="spinner-container">
                <LoadingSpinnerTable show={loading} />
              </div>
            ) : manufacturerVersionListData?.Manufacturer?.length > 0 ? (
              <>
                {manufacturerVersionListData?.Manufacturer?.map(
                  (data, index) => (
                    <tbody>
                      <tr className="table-rows1 ">
                        <td className="table-each-row-data">
                          {(manufacturerVersionListData?.pagination
                            ?.currentPage -
                            1) *
                            10 +
                            (index + 1)}
                        </td>
                        <td className="table-each-row-data">
                          {data.employee_id}
                        </td>
                        <td className="table-each-row-data">{data.name}</td>
                        <td className="table-each-row-data">
                          {data?.orders?.length}
                        </td>
                        <td className="table-each-row-data text-center">
                          {data?.vendorDistributors?.length}
                        </td>
                        {data?.status === "active" ? (
                          <td className="table-each-row-data text_green">
                            Active
                          </td>
                        ) : data?.status === "inactive" ? (
                          <td className="table-each-row-data text_red">
                            Inactive
                          </td>
                        ) : (
                          <td className="table-each-row-data Medium_Purple">
                            Draft
                          </td>
                        )}
                        <td className="table-each-row-data ">
                          <div className="all-button d-flex align-items-center">
                            <button
                              className="button-view"
                              type="button"
                              onClick={() =>
                                navigate(
                                  `/manufacturer/premium-list/version-view/${data.id}`
                                )
                              }
                            >
                              <span className=""> View</span>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  )
                )}
              </>
            ) : (
              <>
                <div>
                  <tr className="nodata-container">~ No Data found ~</tr>
                </div>
              </>
            )}
          </TableContainer>

          {manufacturerVersionListData?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={manufacturerVersionListData?.pagination?.currentPage}
              totalPages={manufacturerVersionListData?.pagination?.totalPages}
              path={"/manufacturer/premium-list/version-list"}
              filters={`${queryString}`}
            />
          )}
        </>
      </div>
    </MainLayout>
  );
};

export default ManufacturerPremiumVersionTable;
